import React, { useState, useEffect } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Nav = () => {
  const { currentLang, toggleLanguage } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`} id="navbar">
        <div className="nav-container container">
          <a href="#home" className="logo" aria-label="WATEEN Production">
            <img
              src={`${process.env.PUBLIC_URL}/wateenlogo.png`}
              alt="WATEEN logo"
              className="logo-img"
            />
          </a>

          <ul className="nav-links" role="menubar" aria-label="Main Navigation">
            <li>
              <a href="#home" data-en="Home" data-ar="الرئيسية">
                {currentLang === "en" ? "Home" : "الرئيسية"}
              </a>
            </li>
            <li>
              <a href="#about" data-en="About" data-ar="من نحن">
                {currentLang === "en" ? "About" : "من نحن"}
              </a>
            </li>
            <li>
              <a href="#services" data-en="Services" data-ar="خدماتنا">
                {currentLang === "en" ? "Services" : "خدماتنا"}
              </a>
            </li>
            <li>
              <a href="#why-us" data-en="Why Us" data-ar="لماذا نحن">
                {currentLang === "en" ? "Why Us" : "لماذا نحن"}
              </a>
            </li>
            <li>
              <a href="#clients" data-en="Clients" data-ar="عملاؤنا">
                {currentLang === "en" ? "Clients" : "عملاؤنا"}
              </a>
            </li>
            <li>
              <a href="#contact" data-en="Contact" data-ar="تواصل معنا">
                {currentLang === "en" ? "Contact" : "تواصل معنا"}
              </a>
            </li>
          </ul>

          <div className="nav-actions">
            <button
              className="mobile-menu-btn"
              type="button"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Open menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <button
              className="lang-toggle"
              type="button"
              onClick={toggleLanguage}
              aria-label="Toggle Language"
            >
              <span
                className="lang-en"
                style={{ display: currentLang === "en" ? "inline" : "none" }}
              >
                عربي
              </span>
              <span
                className="lang-ar"
                style={{ display: currentLang === "ar" ? "inline" : "none" }}
              >
                English
              </span>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-content">
            <ul className="mobile-nav-links">
              <li>
                <a
                  href="#home"
                  onClick={closeMobileMenu}
                  data-en="Home"
                  data-ar="الرئيسية"
                >
                  {currentLang === "en" ? "Home" : "الرئيسية"}
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={closeMobileMenu}
                  data-en="About"
                  data-ar="من نحن"
                >
                  {currentLang === "en" ? "About" : "من نحن"}
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  onClick={closeMobileMenu}
                  data-en="Services"
                  data-ar="خدماتنا"
                >
                  {currentLang === "en" ? "Services" : "خدماتنا"}
                </a>
              </li>
              <li>
                <a
                  href="#why-us"
                  onClick={closeMobileMenu}
                  data-en="Why Us"
                  data-ar="لماذا نحن"
                >
                  {currentLang === "en" ? "Why Us" : "لماذا نحن"}
                </a>
              </li>
              <li>
                <a
                  href="#clients"
                  onClick={closeMobileMenu}
                  data-en="Clients"
                  data-ar="عملاؤنا"
                >
                  {currentLang === "en" ? "Clients" : "عملاؤنا"}
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={closeMobileMenu}
                  data-en="Contact"
                  data-ar="تواصل معنا"
                >
                  {currentLang === "en" ? "Contact" : "تواصل معنا"}
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Nav;
